import React from "react";
import i18n from "../../../i18n";
import { Spinner, Card, H4, Callout } from "@blueprintjs/core";
import { Trans } from "react-i18next";

import { authenticatedGetFetch } from "../../../utils/AuthenticatedFetch";
import { Chart } from "chart.js";
import "chartjs-adapter-date-fns";
import { generic_colors } from "../../Charts/Colors";

export default class HistoFinancial extends React.Component {
  constructor() {
    super();
    this.state = {
      data: [],
      labels: [],
      loading: true,
      chart: undefined,
      unauthorized: false
    };
  }

  ac = new AbortController();

  componentDidMount() {
    if (localStorage.getItem('perm_financial') === "true") {
      // create the reference on the constructor lead to troubles about canvas ref and chart not destroyed before the now one is created ...
      this.canvasRef = React.createRef();
      this.setState({ loading: true });
      if (this.props.urlsearchparams) {
        authenticatedGetFetch('/financial/evolution?' + this.props.urlsearchparams,
          (res) => {
            this.setState({
              data: res['amount'],
              labels: res['date'],
              loading: false
            }, () => {
              const datasets = [];
              for (let i = 0; i < this.state.data.length; i++) {
                if (this.state.data[i] !== undefined && this.state.data[i] !== null) {
                  datasets.push({
                    label: i18n.t("mop" + i),
                    data: this.state.data[i],
                    fill: 'none',
                    backgroundColor: generic_colors[i],
                    pointRadius: 1,
                    borderColor: generic_colors[i],
                    lineTension: 0.3
                  });
                }
              }
              if (datasets.length > 0) {
                if (this.state.chart === undefined) {
                  this.setState({
                    chart: new Chart(this.canvasRef.current, {
                      type: 'line',
                      options: {
                        responsive: true,
                        maintainAspectRatio: true,
                        scales: {
                          yAxes: {
                            ticks: {
                              min: 0,
                            }
                          },
                          //xAxes: Xtime,
                        },
                        plugins: {
                          zoom: {
                            pan: {
                              enabled: true,
                              mode: 'x'
                            },
                            zoom: {
                              wheel: {
                                enabled: true
                              },
                              pinch: {
                                enabled: true
                              },
                              mode: 'x'
                            },
                            limits: {
                              x: { min: 'original', max: 'original', minRange: 3 }
                            }
                          }
                        },
                        interaction: {
                          intersect: false,
                          mode: "index",
                        }
                      },
                      data: {
                        labels: this.state.labels,
                        datasets: datasets,
                      }
                    })
                  });
                }
                else {
                  this.state.chart.update();
                }
              }
            });
          }, null, this.ac.signal);
      }
    } else {
      this.setState({ unauthorized: true });
    }
  }

  componentWillUnmount() {
    this.ac.abort();
    if (this.state.chart !== undefined && this.state.chart !== null)
      this.state.chart.destroy();
  }

  render() {
    if (this.state.unauthorized) {
      return <Callout intent="warning"><Trans>you are not allowed to visualize element:</Trans><Trans>evolution de la recette par moyens de paiement</Trans><br /><Trans></Trans><Trans>for any change of your permissions please contact an administrator</Trans></Callout>
    }
    else if (this.props.urlsearchparams)
      return (this.state.loading || this.state.data === undefined) ?
        <Spinner />
        : (this.state.data.length > 0) ?
          <Card className="medium-chart-container">
            <H4 className="chart-title noselect"><Trans>evolution de la recette par moyens de paiement</Trans></H4>
            <canvas ref={this.canvasRef} />
          </Card>
          : null
        ;
    else
      return null;
  }
}
